import React, { Component } from 'react';
import Banner from "../modules/Banner";
import OurValues from "../homepage/OurValues/OurValues";
import Partners from "../homepage/Partners/Partners";
import About from "../homepage/About/About";
import OurTeam from "../homepage/OurTeam/OurTeam";
import Services from "../homepage/Services/Services";
import RegisterBlock from "../modules/RegisterBlock";
import Careers from "../homepage/Careers/Careers";
import HeroHome from "../homepage/HeroHome/HeroHome";
import globals from '../globals';
import Supporting from "../homepage/Supporting/Supporting";

class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            title: '',
            leadCopy: [],
            banner1: '',
            banner2: '',
            ourValues: {},
            partners: {},
            about: {},
            ourTeam: {},
            services: {},
            supporting: {},
            careers: {},
            staff: {}
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        fetch('/api/home')
            .then(result => result.json())
            .then((result) => {
                this.setState(result);
                globals.animatePageIn(this.container);
            });
    }

    render() {
        return (
            <div ref={(el) => this.container = el} style={{opacity: 0}}>
                <HeroHome title={this.state.title} leadCopy={this.state.leadCopy} />
                <Banner title={this.state.banner1} doAnimate={true} />
                <OurValues data={this.state.ourValues} />
                <Partners data={this.state.partners} />
                <About data={this.state.about} />
                {/*<OurTeam data={this.state.ourTeam} />*/}
                {/*<Banner title={this.state.banner2} />*/}
                <div className="services-trigger" />
                <Services data={this.state.services} />
                <RegisterBlock />
                <div className="supporting-trigger" />
                <Supporting data={this.state.supporting} />
                <Careers data={this.state.careers} />
            </div>
        );
    }
}

export default Home;


// WEBPACK FOOTER //
// ./resources/assets/js/pages/Home.js